import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Container from "@mui/material/Container";
import {
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Button,
  Card,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  deleteAllUserdata,
  deleteSpecificUserdata,
  getAvailableUserdata,
} from "../pages/EraseUserdata/EraseUserdata.thunk";
import Swal from "sweetalert2";

const UserdataToBeErased = [
  { value: "user", text: "User", label: "UserCount" },
  { value: "tchStatus", text: "User Status", label: "UserStatusCount" },
  { value: "timeSpent", text: "Time Spent", label: "UserCount" },
  {
    value: "attendance",
    text: "Student Attendance",
    label: "studentAttendanceCount",
  },
  { value: "pedagogyTraining", text: "Pedagogy", label: "TransPedagogyCount" },
  { value: "21stTraining", text: "21st", label: "Trans21stCount" },
  { value: "technologyTraining", text: "Tech", label: "TransTechCount" },
  {
    value: "studTtlQuiz",
    text: "Student Assessment",
    label: "TransTtlQuizCountsStudent",
  },
  {
    value: "tchTtlQuiz",
    text: "Common Monthly Quiz",
    label: "TransTtlQuizCountsTeacher",
  },
  {
    value: "pgeActivity",
    text: "PGE Activity",
    label: "TransStudentActivityPge",
  },
  {
    value: "eceActivity",
    text: "ECE Activity",
    label: "TransStudentActivityEce",
  },
  {
    value: "flnActivity",
    text: "FLN Activity",
    label: "TransStudentActivityFln",
  },
  {
    value: "communityActivity",
    text: "Community Activity",
    label: "TransStudentActivityCommunity",
  },
  { value: "introQuiz", text: "Intro Quiz", label: "TransIntroQuizCount" },
  { value: "coinsTrans", text: "Coins Transaction", label: "UserCount" },
];

const ClearUserdata = ({ id }) => {
  //----------------------State handling--------------------------------
  // console.log("id received in ErasedataList:", id);

  // State to store selected values
  const [selectedValues, setSelectedValues] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const [checkboxes, setCheckboxes] = useState(
    UserdataToBeErased.map(() => false)
  );

  const idSent = { id };
  const deleteId = idSent.id;

  //-----------------------------------------------------------------------

  const [availableData, setAvailableData] = useState({});
  // console.log("availableData---->", availableData);

  let availData = [];
  // console.log("availData---->", availData);
  useEffect(() => {
    const data = {
      userid: deleteId,
    };
    getAvailableUserdata(data).then((res) => {
      if (res.status === 200) {
        setAvailableData(res.data);
        availData.push(res.data);
      }
    });
  }, [deleteId, checkboxes]);

  const filteredData = Object.keys(availableData)
    .map((key) => {
      const matchingItem = UserdataToBeErased.find(
        (item) => item.label === key
      );
      return matchingItem && availableData[key] === 1 ? matchingItem : null;
    })
    .filter((item) => item !== null);

  // console.log("filterData----------------------->", filteredData);

  //--------------------When all is checked-------------------------------
  const handleAllChange = (event) => {
    const newAllChecked = event.target.checked;
    setAllChecked(newAllChecked);
    const filteredValues = filteredData.map((item) => item.value);

    setCheckboxes(
      UserdataToBeErased.map((item) => {
        return filteredValues.includes(item.value) ? newAllChecked : false;
      })
    );

    if (newAllChecked) {
      setSelectedValues(filteredValues);
    } else {
      setSelectedValues([]);
    }
  };

  //------------------------------------------------------------------------

  //--------------When individual checkbox is checked-------------------
  const handleCheckboxChange = (index) => (event) => {
    const newCheckboxes = [...checkboxes];
    const selectedValue = UserdataToBeErased[index].value;

    if (filteredData.some((item) => item.value === selectedValue)) {
      newCheckboxes[index] = event.target.checked;

      setCheckboxes(newCheckboxes);
      setAllChecked(newCheckboxes.every((checked) => checked));

      setSelectedValues((prevSelectedValues) => {
        if (event.target.checked) {
          return [...prevSelectedValues, selectedValue];
        } else {
          return prevSelectedValues.filter((value) => value !== selectedValue);
        }
      });
    } else {
      toast.error("The data is already empty !");
    }
  };

  //-------------------------------------------------------------------------

  const deleteUserdata = async () => {
    if (selectedValues.length === 0) {
      toast.error("Select at least one field to delete !");
    } else {
      const { value: inputValue } = await Swal.fire({
        title: "Enter Password !",
        input: "text",
        inputPlaceholder: "Enter your password to delete the userdata.",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
        confirmButtonColor: "#3085d6",
        inputValidator: (value) => {
          if (!value) {
            return "Please enter the password !";
          } else if (value !== "DELETE") {
            return "Password is incorrect !";
          }
        },
      });

      if (inputValue === "DELETE") {
        if (allChecked) {
          const data = {
            userid: deleteId,
            models: ["all"],
          };
          deleteAllUserdata(data).then((res) => {
            if (res && res.status === 200) {
              setAllChecked(false);
              setCheckboxes(UserdataToBeErased.map(() => false));
              toast.success("All the userdata have been deleted !");
            } else {
              toast.error("Sorry, userdata couldn't be deleted !");
            }
          });
        } else {
          const data = {
            userid: deleteId,
            models: selectedValues,
          };
          deleteSpecificUserdata(data).then((res) => {
            if (res && res.status === 200) {
              setCheckboxes(UserdataToBeErased.map(() => false));
              toast.success("All the selected userdata have been deleted !");
            } else {
              toast.error("Sorry, userdata couldn't be deleted !");
            }
          });
        }
      }
    }
  };

  // console.log("selectedValues--------------->", selectedValues);
  // console.log("allChecked--------------->", allChecked);
  // console.log("checkboxes--------------->", checkboxes);
  // console.log("available userdata------------------->", availableData);

  return (
    <Container>
      {id && (
        <Card
          style={{
            display: "flex",
            paddingLeft: "40px",
            width: "83.5%",
            marginLeft: "-28px",
            marginTop: "20px",
            height: "590px",
            flexWrap: "wrap",
          }}
        >
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={allChecked}
                  onChange={handleAllChange}
                  name="all"
                  style={{ color: "red" }}
                />
              }
              label="All"
            />

            {}

            <Grid container spacing={2}>
              {UserdataToBeErased.map((item, index) => (
                <Grid item xs={4} key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkboxes[index]}
                        onChange={handleCheckboxChange(index)}
                        name={item.text}
                        style={{ color: "red" }}
                      />
                    }
                    label={item.text}
                  />
                </Grid>
              ))}
            </Grid>
            <Button
              variant="contained"
              style={{
                marginBottom: "70px",
                width: "130px",
                marginTop: "30px",
                backgroundColor: "red",
              }}
              onClick={deleteUserdata}
            >
              Delete Data
            </Button>
          </FormGroup>
        </Card>
      )}
      <ToastContainer />
    </Container>
  );
};

export default ClearUserdata;
